import * as React from 'react';
import { renderWithoutShadow } from "@tlc/ls2pac/components/ShadowUtils";
import { TemplateEngine } from "../../../../../js/lib/TemplateEngine";
import { TLCEventManager } from "../../../../../js/lib/events/EventManager";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { ApplicationData } from "../../ApplicationData";
import { LibraryThing } from "../../widget/LibraryThingWidget";
import { BaseDetailView } from "./BaseDetailView";
import { GlobalConfigProvider } from "@tlc/ls2pac/components/GlobalConfig";
import { LocationConfigurationProvider } from "@tlc/ls2pac/components/LocationConfiguration";
import { StackMapProvider } from "@tlc/ls2pac/components/Stackmap";
import { BranchLimitProvider } from "@tlc/ls2pac/components/BranchLimits";
import { LocalCopies } from '@tlc/ls2pac/components/pages/resource/LocalCopies';
import { LocalHoldingsBranchProvider } from '@tlc/ls2pac/components/pages/resource/LocalHoldingsBranch';
import { AccountProvider } from '@tlc/ls2pac/components/Account';
import { StationLocationProvider } from '@tlc/ls2pac/components/StationLocation';

export class Titles_FullDetails extends BaseDetailView {
  constructor(options) {
    options = options || {};

    options.resultsTemplate = "tmpl/details/titles_fullDetails.html";

    options.id = LS2PAC_CONSTANTS.Ids.DetailsPage.fullDetailsContainer;

    super(options);

    this.detailsTemplate = "tmpl/details/titles_fullDetails_marcData.html";

    this.tagFormTemplate = "tmpl/details/titles_fullDetails_tagForm.html";

    this.rssTemplate = "tmpl/details/titles_fullDetails_rss.html";

    this.readingLevelTemplate =
      "tmpl/details/titles_fullDetails_readingLevels.html";

    this.addListeners();
  }
  initSyndeticsSummary() {
    var summaryContainer = $(
      "#" + LS2PAC_CONSTANTS.Ids.DetailsPage.fullDetails_summary
    ).find(".summary");
    var selector =
      "#" + LS2PAC_CONSTANTS.Ids.DetailsPage.fullDetails_summary + " .summary";
    summaryContainer.empty();
    LibraryThing.addEnrichment(
      summaryContainer,
      LibraryThing.enums.enrichments.summary
    );
    this.refreshSUMetaData(selector, this.currentResource);
  }
  getCopiesTableContainer() {
    let copiesTableHasRendered = document.getElementById('copies_Table');
    if (copiesTableHasRendered) {
      // TODO destroy the react node
      copiesTableHasRendered.remove();
    }

    if(ApplicationData.locationConfiguration.isDisplayCopiesFirst()){
      return document.getElementById(LS2PAC_CONSTANTS.Ids.DetailsPage.fullDetails_CopiesTableFirst)
    }

    $("#" + this.id).append(
      $("<div></div>", {
        id: LS2PAC_CONSTANTS.Ids.DetailsPage.fullDetails_copiesTable,
      })
    );

    return document.getElementById(LS2PAC_CONSTANTS.Ids.DetailsPage.fullDetails_copiesTable)

  }
  load(resourceData, index, viewName) {
    
    var _this = this;

    if (parseInt(this.currentResource.rtype, 10) == 1) {
      const copiesTableContainer = this.getCopiesTableContainer();
      // const branchToUse = ApplicationData.getBranchToUseForAvailability();
      renderWithoutShadow(
        <div id="copies_Table">
          <GlobalConfigProvider>
          <LocationConfigurationProvider>
            <StackMapProvider>
              <BranchLimitProvider>
                <StationLocationProvider>
                  <AccountProvider>
                    <LocalHoldingsBranchProvider>
                      <LocalCopies resource={this.currentResource} />
                    </LocalHoldingsBranchProvider>
                  </AccountProvider>
                </StationLocationProvider>
              </BranchLimitProvider>
            </StackMapProvider>
          </LocationConfigurationProvider>
          </GlobalConfigProvider>
        </div>, 
        copiesTableContainer, ApplicationData.language)
        this.parentClass.setRequestButton();

      this.addEvents();

      if (LibraryThing.hasSummary()) {
        this.initSyndeticsSummary();
      } else {
        $("#fullDetails_summary").hide();
      }

      TLCEventManager.fireEvent(
        LS2PAC_CONSTANTS.Events.onGetFullDetailsFromMarcRecord,
        { resource: this.currentResource }
      );

      TemplateEngine.fetch(
        this.readingLevelTemplate,
        LS2PAC_CONSTANTS.Ids.DetailsPage.fullDetails_ReadingLevelSummary,
        this.currentResource,
        function () {},
        TemplateEngine.method.overwrite
      );
    } else {
      TemplateEngine.fetch(
        this.rssTemplate,
        LS2PAC_CONSTANTS.Ids.DetailsPage.fullDetails_marcData,
        this.currentResource,
        function () {
          _this.parentClass.updatePagingControls();
        },
        TemplateEngine.method.overwrite
      );
    }
  }
  addEvents() {
    if (this.hasBoundEvents == false) {
      this.hasBoundEvents = true;
    }
  }
  addListeners() {
    var _this = this;

    TLCEventManager.addListener(
      LS2PAC_CONSTANTS.Events.onGetFullDetailsFromMarcRecordResponse,
      function (event) {
        if (
          _this.currentResource.id !=
          parseInt($("#" + _this.id).attr("data-resourceId"), 10)
        ) {
          $("#" + _this.id).attr("data-resourceId", _this.currentResource.id);

          TemplateEngine.fetch(
            _this.detailsTemplate,
            LS2PAC_CONSTANTS.Ids.DetailsPage.fullDetails_marcData,
            event.details,
            function () {
              if (
                parseInt(_this.currentResource.rtype, 10) === 1 &&
                ApplicationData.locationConfiguration.allowTagging()
              ) {
                TemplateEngine.fetch(
                  _this.tagFormTemplate,
                  LS2PAC_CONSTANTS.Ids.DetailsPage.detailsTagsContainer,
                  _this.currentResource,
                  function () {
                    _this.parentClass.updatePagingControls();
                  }
                );
              } else {
                _this.parentClass.updatePagingControls();
              }
            },
            TemplateEngine.method.overwrite
          );
        }
      }
    );
  }
}
